import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getRouteList } from "../../services/route.services";
import {
  CAvatar,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CProgress,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CToaster,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import {
  cibCcAmex,
  cibCcApplePay,
  cibCcMastercard,
  cibCcPaypal,
  cibCcStripe,
  cibCcVisa,
  cibGoogle,
  cibFacebook,
  cibLinkedin,
  cifBr,
  cifEs,
  cifFr,
  cifIn,
  cifPl,
  cifUs,
  cibTwitter,
  cilCloudDownload,
  cilPeople,
  cilPlus,
  cilUser,
  cilUserFemale,
} from "@coreui/icons";
import CustomPagination from "../../components/CustomPagination";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import { FaEdit } from "react-icons/fa";
import ReactSelect from "react-select";
import { getActiveCountryList } from "src/services/country.services";

const ManageRouteTable = () => {
  const toaster = useRef();
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const [toast, addToast] = useState("");
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(15);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countrySelectOptions, setCountrySelectOptions] = useState([]);

  useEffect(() => {
    if (userInfo?.userType === "superAdmin") {
      getActiveCountryList({ limit: 100, page: 1 })
        .then((response) => {
          if (response.success && response.data) {
            let options = response.data.map((element) => ({
              value: `${element._id}`,
              label: `${element.name}`,
            }));
            setCountrySelectOptions(options);
          }
        })
        .catch((error) => console.log(error));
    } else {
      getRouteItem(currentPage);
    }
  }, []);

  useEffect(() => {
    if (userInfo?.userType === "superAdmin") getRouteItem();
  }, [selectedCountry]);

  const getRouteItem = (page) => {
    setIsLoading(true);
    getRouteList({ limit, page, country: selectedCountry?.value })
      .then(async (response) => {
        setIsLoading(false);
        setCount(response.count);
        setData(response.data);
        setData(response.data);
        const totalPages = Math.ceil(response.count / limit);
        setTotalPages(totalPages);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    getRouteItem(newPage);
  };
  const handleCountryChange = (selectedOption) => {
    setCurrentPage(1);
    if (selectedOption) {
      setSelectedCountry(selectedOption);
    } else {
      setSelectedCountry(null);
    }
  };

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={5}>
              <h4 id="traffic" className="card-title mb-0">
                Manage Route - Total: {count}
              </h4>
            </CCol>

            <CCol sm={7} className="d-none d-md-block">
              <div className="d-flex justify-content-end gap-4">
                {userInfo && userInfo.userType === "superAdmin" && (
                  <ReactSelect
                    value={selectedCountry}
                    onChange={handleCountryChange}
                    options={countrySelectOptions}
                    isClearable={true}
                    placeholder="Select Country"
                  />
                )}
                <Link to="/create-route">
                  <CButton>
                    <CIcon icon={cilPlus} />
                    &nbsp; Create New Route
                  </CButton>
                </Link>
              </div>
            </CCol>
          </CRow>
          <br />
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell className="text-center">
                  Action
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Route Name
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Route Code
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Starting Point
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Ending Point
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Start Time
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Duration
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Distance
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Trip Type
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Trip Urgency
                </CTableHeaderCell>
                {/* <CTableHeaderCell className="text-center">Stores</CTableHeaderCell> */}
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="8">Loading...</CTableDataCell>
                </CTableRow>
              ) : data.length == 0 ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="8">No data available</CTableDataCell>
                </CTableRow>
              ) : (
                data.map((item, index) => (
                  <CTableRow
                    v-for="item in tableItems"
                    key={index}
                    className={
                      item.tripUrgency == "emergency" ? "emergency-color" : ""
                    }
                  >
                    <CTableDataCell className="text-center">
                      <Link to={`/edit-route/${item._id}`}>
                        <CButton
                          size="sm"
                          color="secondary"
                          style={{ color: "white" }}
                        >
                          <FaEdit />
                        </CButton>
                      </Link>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item.name}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item.routeCode}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item?.startingPoint?.name}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item?.endingPoint?.name}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item.startTime}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item.duration}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item.distance}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item.tripType === "pickUp" ? "Pick-up" : "Drop-off"}
                    </CTableDataCell>
                    <CTableDataCell className="text-center text-capitalize">
                      {item.tripUrgency}
                    </CTableDataCell>
                    {/* <CTableDataCell className='text-center'>{item.tripType}</CTableDataCell> */}
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>
      <DeleteModal
        visible={visibleDeleteModal}
        setVisibleDeleteModal={setVisibleDeleteModal}
        addToast={addToast}
      />
      {/* <CToaster ref={toaster} push={toast} placement="top-end" /> */}
    </>
  );
};

export default ManageRouteTable;
